import React, { useState } from 'react'
import { ThemeProvider } from 'styled-components'
const GatsbyContext = React.createContext()

// Provider, Consumer

const GatsbyProvider = ({ children }) => {
  const [isFullscreenOpen, setIsFullscreenOpen] = useState(false)
  const [activeMenuID, setActiveMenuID] = useState(1)
  const [theme, setTheme] = useState({
    isFullscreenOpen: false,
    colors: {
      primary: '#0058a9',
      secondary: '#2fbbf8',
      header: '#ebfbff',
      body: '#fff',
      font: 'rgba(255,255,255,0.7)',
      footer: '#4c545c'
    },
    containerWidth: '1280px',
    mobile: '768px'
  })

  const showFullscreen = () => {
    setIsFullscreenOpen(true)
  }
  const hideFullscreen = () => {
    setIsFullscreenOpen(false)
  }
  const handleFullscreen = () => {
    setIsFullscreenOpen(!isFullscreenOpen)
    setTheme({ ...theme, isFullscreenOpen: !isFullscreenOpen })
  }

  return (
    <GatsbyContext.Provider
      value={{
        isFullscreenOpen,
        handleFullscreen,
        showFullscreen,
        hideFullscreen,
        theme,
        setTheme,
        activeMenuID,
        setActiveMenuID
      }}
    >
      <ThemeProvider theme={theme} status={isFullscreenOpen}>
        {children}
      </ThemeProvider>
    </GatsbyContext.Provider>
  )
}

export { GatsbyContext, GatsbyProvider }
